// --- frontend/pages/SignupPage.jsx ---
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import SignUpFlow from '../components/flows/signUpFlow';
//import SignUpForm from '../components/SignUpForm';
//import Navbar from '../components/Navbar';
//import Footer from '../components/Footer';

const SignUp = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow bg-gray-100 py-8">
        <h1 className="text-3xl font-bold text-center mb-6">Create Your Account</h1>
        {/*<SignUpForm />*/}
        <SignUpFlow />

      </main>
    </div>
  );
};

export default SignUp;
